import { useEffect, useState } from "react"
import classNames from "./styles.module.scss"
import Geo from '../../../shared/icons/geo.svg'
import { getCenterCoordinates, getGeometry, getSearchChilds } from "../../../shared/RKApi"
import GeoJSON from 'ol/format/GeoJSON';
import { transformPointsStructureFromWGS } from "../../../shared/MvtLogicFunctios/index.js";
import { transform } from 'ol/proj';
import { Feature } from "ol";


export const FiasSearch = (props: { SetObjectClick:Function, regionsAvaliable: [any] | null, map: any, setInfoBlock: Function, setActive: Function }) => {
  const [adressArray, SetAdressArray] = useState<Array<any> | undefined | null>(null)
  // eslint-disable-next-line
  const [locations, setLocations] = useState<[] | null>(null)
  const [searchChilds, setSearchChilds] = useState<any>(null)
  const [inputValue, setInputValue] = useState<string>('')
  const [focused, setFocused] = useState<boolean>(false)
  // eslint-disable-next-line
  const [region, setRegion] = useState<any>(null)
  const [searchParent, setSearchParent] = useState<string | undefined>("df3d7359-afa9-4aaa-8ff9-197e73906b1c")
  const [top, setTop] = useState<number>()
  const [left, setLeft] = useState<number>()
  const [geometry, setGeometry] = useState<any>()
  const [current, setCurrent] = useState<any>()
  const [time, setTime] = useState<NodeJS.Timeout | null>(null)
  const [regionChilds, setRegionChilds] = useState<any>()
  const [regionsAvaliable, setRegionsAvaliable] = useState<any>()


  function keyDown(e: KeyboardEvent) {
    let list = document.getElementById('searchInputHinterslist')
    let arrlist = list?.childNodes
    const results = arrlist && Array.from(arrlist.values()).map((parser_item) => { return parser_item });

    let setGray = (results: any, j: number, list: any) => {

      results.forEach((el: any, i: number) => {
        //@ts-ignore
        if (i !== j) {
          el && el.style.setProperty('background-color', 'white')
        }
        else {
          //@ts-ignore
          el && el.style.setProperty('background-color', 'rgba(0, 0, 0, 0.094)')
          let topPos = el.offsetTop;
          list.scrollTop = topPos;
        }
      })
    }


    if (results) {

      if (e.keyCode === 13) {
        results.forEach((el, i) => {
          //@ts-ignore
          if (el.style.backgroundColor === 'rgba(0, 0, 0, 0.094)') {
            //@ts-ignore
            el.click()
          }
        })
      }

      if (e.keyCode === 38) {
        let j = null
        results.forEach((el, i) => {
          //@ts-ignore
          if (el.style.backgroundColor === 'rgba(0, 0, 0, 0.094)') {
            if (i > 0) {
              j = i - 1
            }
            else {
              j = results.length - 1
            }
          }
        })
        if (!j) j = 0
        setGray(results, j, list)

      }

      if (e.keyCode === 40) {
        let j = null
        results.forEach((el, i) => {
          //@ts-ignore
          if (el.style.backgroundColor === 'rgba(0, 0, 0, 0.094)') {
            if (i < results.length - 1) {
              j = i + 1
            }
            else {
              j = 0
            }
          }
        })
        if (!j) j = 0
        setGray(results, j, list)
      }
    }
  }

  useEffect(() => {
    getCenterCoordinates(setLocations)
    setTimeout(() => {
      changeButtPosition()
    }, 1000);

    window.addEventListener('keydown', (e) => keyDown(e))
    return window.removeEventListener('keydown', (e) => keyDown(e))
    // eslint-disable-next-line
  }, [])

  function backDown(e: any) {
    if (e.keyCode === 8) {
    e.stopPropagation();
      let value = ''
      let input = document.getElementById('searchInput')
      //@ts-ignore
      if (input) value = input.value
      if (value.length < 1) delBack()
    }
  }

  function changeButtPosition() {
    let topButton = document.getElementById('topButton')
    let mapButton = document.getElementById('mapButton')
    let top = 120
    if (topButton && top < (topButton.offsetTop + topButton.clientHeight + 20)) top = topButton.offsetTop + topButton.clientHeight + 20
    mapButton && mapButton.style.setProperty('top', top + 'px')
  }
  window.onresize = function (event) {
    changeButtPosition()
  }

  useEffect(() => {
    changeButtPosition()
  }, [adressArray])

  useEffect(() => {
    setTimeout(() => {
      let input = document.getElementById('searchInput')
      input && setLeft(input.offsetLeft)
      input && setTop(input.offsetTop + input.clientHeight)
    }, 1000);
  }, [props, inputValue])

  useEffect(() => {
    let tmpLayer: any
    props.map && props.map.current.getLayers().getArray().forEach((layer: any) => {
      if (layer.get('name') === 'temp') tmpLayer = layer
    });

    if (tmpLayer && geometry && geometry.geometry) {
      props.setActive({
        regions: false,
        municipals: false,
        settlement: false,
        cities: false,
        localities: false,
        streets: false,
        houses: false,
      })
      tmpLayer.getSource().clear()
      let mercGeometry = {
        type: geometry.geometry.type,
        coordinates: transformPointsStructureFromWGS(geometry.geometry.coordinates)
      }

      let features = new GeoJSON().readFeatures(
        {
          type: 'FeatureCollection',
          crs: {
            type: 'name',
            properties: {
              name: 'EPSG:3857',
            },
          },
          features: [
            {
              type: 'Feature',
              geometry: mercGeometry,
              properties: { name: "123" }
            }
          ]
        },
        { dataProjection: 'EPSG:3857' }
      );

      let feature = features[0] as Feature;

      feature.set('current', current)
      feature.set('geomApi', geometry)
      props.setInfoBlock(feature)
      let extent = feature?.getGeometry()?.getExtent();
      props.map && props.map.current.getView().fit(extent, { padding: [30, 30, 30, 30] });

      tmpLayer.getSource().addFeature(feature);

    }
    // eslint-disable-next-line
  }, [geometry, props.map, current])


  useEffect(() => {
    setRegionChilds(props.regionsAvaliable)
    setRegionsAvaliable(props.regionsAvaliable)
  }, [props.regionsAvaliable])
  
  useEffect(() => {
    let changeFunc = () => {
      if (!region) {
        // let array = locations
        // array && array.length > 0 && setSearchChilds(array)
      }
      else {
        setRegionChilds(null)
        getSearchChilds(region.code, searchParent, inputValue, setSearchChilds)
      }
    }


    if (time) clearTimeout(time)
    setTime(setTimeout(() => {
      changeFunc()
      time && clearTimeout(time)
    }, 200))
    // eslint-disable-next-line
  }, [inputValue, region, props.regionsAvaliable])

  useEffect(() => {
    if (searchChilds && searchChilds.length < 1) {
      // setFocused(false)
      setSearchChilds(undefined)
    }
  }, [searchChilds])


  useEffect(() => {
    let input = document.getElementById('searchInput')

    if (input) {

      if (focused) {
        input.focus()
      }
      else {
        input.blur()
      }

    }

  }, [focused, searchChilds])

  useEffect(() => {
    if (current === null) {
      props.setInfoBlock(null)

      if (props.map) {
        props.map.current.getLayers().getArray().forEach((layer: any) => {
          if (layer.get('name') === 'temp') {
            layer.getSource().clear()
          }
        });
        props.map.current.getOverlayById('popuping').setPosition(undefined)
      }
      props.SetObjectClick(null)
    }

    // eslint-disable-next-line
  }, [current])


  function onInputHandler(e: React.ChangeEvent<HTMLInputElement>) {
    let val = e.target.value.replace(/[&+=,.]/g, "")
    setInputValue(val)
    let regArr: any[] = []
    if (regionChilds !== null) {
      regionsAvaliable.forEach((reg: any) => {
        if (reg.name.toLowerCase().includes(val.toLowerCase())) regArr.push(reg)
      })
      setRegionChilds(regArr)
    }
  }

  function setChildFunction(child: any, reg: boolean = false) {

    if (child) {
      setCurrent(child)
      setSearchParent(child.guid)
      setGeometry(null)
      setInputValue('')
      setSearchChilds(undefined)
      if (reg) {
        getGeometry(child.code, undefined, setGeometry)
      }
      else {
        getGeometry(region.code, child.guid, setGeometry)
      }
    }

  }
  
  var delBack=()=> {

    if (adressArray) {

      if (adressArray.length > 1) {
        setChildFunction(adressArray.slice()[adressArray.length-2].child)
      }
      else clickOnBlock(null, true)
    }

  }

  useEffect(() => {
    let arr = []
    let child = current
    if (child) {
      if (geometry && geometry?.parents) {
        arr = []
        geometry.parents.forEach((parent: any, i: number) => {

          if (parent.guid!==geometry.guid) arr.push({
            child: parent,
            id: parent.guid,
            name: parent.name
          })

        })
        arr.push({ id: child.guid ? child.guid : null, name: child.name + (child.typenameshort ? (' ' + child.typenameshort) : ''), child: child })
        SetAdressArray(arr)
      }
      else {



        if (!child.hasgeom && adressArray) {
          let arr: any = []
          let stop = false
          adressArray.slice()?.forEach((adr: any) => {
            if (!stop && (adr.child.guid !== child.guid)) arr.push(adr)
            else if (adr.child.guid === child.guid) {
              arr.push(adr)
              stop = true
            }
          })
          setCurrent(null)
          SetAdressArray(arr)
        }
      }
    }
    //eslint-disable-next-line
  }, [geometry, current])


  function clickOnBlock(e: any, adressArrayOrRegion: any) {
    setFocused(false)
    if (adressArrayOrRegion === true) {
      setSearchChilds(null)
      SetAdressArray(null)
      setRegion(null)
      setGeometry(null)
      setSearchParent(undefined)
      setCurrent(null)
      setRegionChilds(regionsAvaliable)
    }
    else {
      if (adressArray && adressArray.length > 0) {
        let j = e.target?.id.split('-')[0]
        setChildFunction(adressArray[j].child)
      }
    }

    setInputValue('')

    setTimeout(() => setFocused(true), 500)
  }

  function setRegionFunc(child: { lon: number; lat: number; zoom: any; }, map: any) {
    
    setRegion(child)
    setChildFunction(child, true)

    map && map.current.getView().setCenter(transform([child.lon, child.lat], 'EPSG:4326', 'EPSG:3857'))

    map && map.current.getView().setZoom(child.zoom)

    setInputValue('')
  }

  return <div id="searchInputFeature" className={classNames.FiasSearch} onClick={() => {
    document.getElementById('searchInput')?.focus()
  }}>
    <img src={Geo} alt="geo icon" className={classNames.searchIcon} />
    <div key={'rus'} id={'rus'} onClick={(e) => {
      clickOnBlock(e, true)
    }} className={classNames.adrPart}><p className={classNames.pAdrPart} id={'pReg'}>Россия</p></div>
    {adressArray?.map((adr, i) => {
      return <div key={'adr' + adr.name} id={i + '-adr'} onClick={(e) => {
        clickOnBlock(e, adressArray)
      }} className={classNames.adrPart}><p className={classNames.pAdrPart} id={i + '-pAdr'}>{adr.name}</p></div>
    })}
    {/* </div> */}
    <input id="searchInput" onPaste={(e:any)=>e.preventDefault()} className={classNames.searchInput} onKeyDown={(e)=>backDown(e)} autoComplete="off" value={inputValue}
      onFocus={(e) => {
        setFocused(true)
        window.addEventListener("click", close)
        function close(e: MouseEvent) {
          //@ts-ignore
          let id = e.target?.id
          if (!id.includes('searchInput')) {
            window.removeEventListener("click", close)
            setFocused(false)
          }
        }
      }} onChange={(e) => onInputHandler(e)} placeholder="Введите адрес" />
    {searchChilds && focused && top && left && <div id="searchInputHinters" style={{ top: top + 10 + 'px', left: left + 'px' }} className={classNames.hinter}>
      <div id="searchInputHinterslist" className={classNames.hinterPadding}>{searchChilds.map((child: any, i: number) => {
        return <div className={classNames.pAdress + (child.hasgeom ? '' : (' ' + classNames.hidden))} style={{ backgroundColor: 'white' }} key={'searchInputHinter' + i} id={"searchInputHinter" + i} onClick={() => {

          child.hasgeom && setChildFunction(child)

        }}>{child.name + (child.typename ? (' ' + child.typename) : '')}<p key={"child1" + i} className={classNames.hinterMini}>{child.parents}</p></div>
          
      })}</div>
    </div>}
    {regionChilds && focused && top && left && <div id="searchInputHinters" key="regLine" style={{ top: top + 10 + 'px', left: left + 'px' }} className={classNames.hinter}>
      <div id="searchInputHinterslist" className={classNames.hinterPadding}>{regionChilds.map((child: any, i: number) => {
        return <p className={classNames.pAdress} style={{ backgroundColor: 'white' }} key={'regInputHinter' + i} id={"regInputHinter" + i} onClick={() => {

          setRegionFunc(child, props.map)

        }}>{child.name + (child.typename ? (' ' + child.typename) : '')}</p>
      })}</div>
    </div>}
  </div>

}